<template>
  <div class="flex wow-container">
    <!-- 左侧-侧边栏 -->
    <div ref="wowSchoolAside" class="wow-aside" v-show="!spreadRetract">
      <menu-aside></menu-aside>
    </div>
    <!-- 展开收起 icon -->
    <div class="spread-retract">
      <div
        class="line"
        :draggable="true"
        @dragstart="handleWidthChangeStart"
        @drag="handleWidthChange"
        @dragend="handleWidthChangeEnd"
      ></div>
      <div
        class="common-icon retract-icon"
        @click="handleSpreadRetract"
        v-show="!spreadRetract"
      >
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/arrow-left.png"
        />
      </div>
      <div
        class="common-icon spread-icon"
        @click="handleSpreadRetract"
        v-show="spreadRetract"
      >
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/arrow-right.png"
        />
      </div>
    </div>
    <!-- 右边-内容  -->
    <div class="wow-content">
      <div class="watermask">
        <water-mask :mask-text="waterMaskText"></water-mask>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import menuAside from "./aside.vue";
import waterMask from "@/components/waterMask.vue";
import { UserModule } from "@/store/module/user";
import { PageModule } from "@/store/module/page";
import { number } from "echarts";
export default {
  components: {
    menuAside,
    waterMask,
  },
  data() {
    return {
      isExpandAll: false, // 是否展开菜单
      spreadRetract: false, // false为收起，true为展开
      asideWidth: 0,
      asideWidthMin: 230,
      asideWidthMax: 0,
      asideDragStart: 0,
    };
  },
  computed: {
    waterMaskText() {
      return (
        "音乐窝  " +
        UserModule.userInfo.staff_name +
        "  " +
        UserModule.userInfo.staff_mobile
      );
    },
  },
  mounted() {
    this.asideWidthMax =
      document.body.clientWidth / 3 < this.asideWidthMin
        ? this.asideWidthMin
        : document.body.clientWidth / 3;
    let asideEl = this.$refs.wowSchoolAside;
    if (asideEl) {
      let cache = sessionStorage.getItem("wow-school-aside-width");
      if (cache) {
        this.asideWidth = Number(cache);
        this.$refs.wowSchoolAside.style.width = Number(cache) + "px";
      } else {
        this.asideWidth = asideEl.clientWidth;
      }
    }
  },
  methods: {
    handleSpreadRetract() {
      this.spreadRetract = !this.spreadRetract;
    },
    handleWidthChangeStart(e) {
      this.asideDragStart = e.clientX;
    },
    handleWidthChange(e) {
      let res = this.asideWidth + e.clientX - this.asideDragStart;
      if (res < this.asideWidthMin) {
        res = this.asideWidthMin;
      }
      if (res > this.asideWidthMax) {
        res = this.asideWidthMax;
      }
      this.$refs.wowSchoolAside.style.width = res + "px";
    },
    handleWidthChangeEnd(e) {
      let res = this.asideWidth + e.clientX - this.asideDragStart;
      if (res < this.asideWidthMin) {
        res = this.asideWidthMin;
      }
      if (res > this.asideWidthMax) {
        res = this.asideWidthMax;
      }
      this.$refs.wowSchoolAside.style.width = res + "px";
      this.asideWidth = res;
      sessionStorage.setItem("wow-school-aside-width", res);
    },
  },
  beforeRouteLeave(to, from, next) {
    PageModule.SET_LAYOUT_FULL_SCREEN_MODE(false);
    next();
  },
  beforeRouteEnter(to, from, next) {
    PageModule.SET_LAYOUT_FULL_SCREEN_MODE(true);
    if (to.path === "/layout/material") {
      next("/layout/material/material_list");
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.wow-container {
  height: 100%;
  align-items: flex-start !important;
  position: relative;
  .wow-aside {
    height: 100%;
    width: 230px;
    min-width: 230px;
    display: flex;
    flex-direction: column;
  }
  .wow-content {
    height: 100%;
    flex: 1;
    width: 0;
    overflow: hidden;
  }
  .spread-retract {
    height: 100%;
    position: relative;
    border-right: 1px solid rgba(231, 232, 234, 1);
    .line {
      height: 100%;
      cursor: ew-resize;
      width: 5px;
      position: absolute;
      top: 0;
      left: -2px;
      z-index: 100;
    }
    &:hover {
      .common-icon {
        display: block;
      }
    }
    .common-icon {
      display: none;
      position: absolute;
      top: 50%;
      width: 15px;
      height: 40px;
      background: white;
      line-height: 55px;
      border-radius: 8px;
      border: 1px solid rgba(237, 237, 238, 1);
      cursor: pointer;
      margin-top: -20px;
      z-index: 101;
      img {
        height: 20px;
        width: 16px;
      }
      &:hover {
        background: rgba(242, 242, 242, 1);
      }
      &.retract-icon {
        left: -8px;
      }
      &.spread-icon {
        left: 0;
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.gray-92 {
  color: rgba(92, 93, 94, 1);
}
.gray-140 {
  color: rgba(140, 141, 142, 1);
}
.font-size-16 {
  font-size: 16px;
}
.font-size-14 {
  font-size: 14px;
}
</style>
